import { render, staticRenderFns } from "./FollowsListModal.vue?vue&type=template&id=524d9477&scoped=true"
import script from "./FollowsListModal.vue?vue&type=script&lang=ts"
export * from "./FollowsListModal.vue?vue&type=script&lang=ts"
import style0 from "./FollowsListModal.vue?vue&type=style&index=0&id=524d9477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d9477",
  null
  
)

export default component.exports